/*global define*/

define([
    'jquery',
    'underscore',
    'backbone',
    '../resources/lang'
], function ($, _, Backbone, lang) {
    'use strict';

    var NavView = Backbone.View.extend({
        template: require('ejs-loader!../templates/Nav.ejs'),
        initialize: function(){
        	this.render();
            this.initDropdowns();
        },
        render: function(){
        	this.$el.html(this.template({
        	    terms: _.extend({}, lang.nav, lang.actions),
                language: language,
                allowLoadAssignment: allowLoadAssignment
        	}));
        },
        initDropdowns: function(){
            var dropdowns = this.$el.find('.dropdown-toggle');
            for (var i = 0; i < dropdowns.length; i++){
                $(dropdowns[i]).dropdown();
            }
        },
        displayAboutModal: function (timer){
            var about = $require('ejs-loader!../templates/Stockroom.ejs')({});
            $(about).on('hidden.bs.modal', function (e) {
              $('.modal-backdrop').remove();
            });
            $(about).modal({
                keyboard: true
            });
        }
    });

    return NavView;
});
